// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading-module__loading___nInj1","rotate":"loading-module__rotate___2B1wq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loading/loading.module.scss
// module id = 1298
// module chunks = 0